import { render, staticRenderFns } from "./purchase-history.vue?vue&type=template&id=5d0812d4&scoped=true"
import script from "./purchase-history.vue?vue&type=script&lang=js"
export * from "./purchase-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0812d4",
  null
  
)

export default component.exports